var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section-catalogBarBox" }, [
    _c("div", { staticClass: "section-catalogBarCont" }, [
      _c("div", { staticClass: "section-catalogBar" }, [
        _c("div", { staticClass: "section-catalogBar__filter" }, [
          _c("div", { staticClass: "left" }, [
            _c(
              "div",
              { staticClass: "provider-filter-menu" },
              [
                _c(
                  "v-menu",
                  {
                    attrs: {
                      "offset-y": "",
                      right: "",
                      attach: ".provider-filter-menu",
                      "content-class": "v-menu-select",
                      "close-on-content-click": false
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  { staticClass: "btn-select" },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "11",
                                      height: "11",
                                      viewBox: "0 0 11 11",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M10.8482 0C10.8949 0.11213 10.9883 0.235474 10.9883 0.347605C11.0117 1.07645 11 1.07645 10.4045 1.68196C9.30679 2.80326 8.19745 3.91335 7.11147 5.04587C7.0414 5.11315 7.01805 5.23649 7.01805 5.33741C7.01805 7.10907 7.01805 8.86952 7.00637 10.6412C7.00637 10.7645 6.95966 10.9439 6.87792 10.9776C6.77282 11.0224 6.59766 10.9888 6.48089 10.9215C5.73355 10.5066 4.99788 10.0693 4.25053 9.64322C4.06369 9.53109 3.98195 9.40775 3.98195 9.1947C3.99363 7.9052 3.99363 6.62691 3.98195 5.33741C3.98195 5.23649 3.9586 5.11315 3.88854 5.04587C2.60403 3.72273 1.29618 2.39959 0 1.07645C0 0.717635 0 0.358818 0 0C3.61996 0 7.22824 0 10.8482 0ZM0.490446 0.5158C0.537155 0.683996 0.537155 0.863405 0.630573 0.953109C1.84501 2.20897 3.05945 3.45362 4.28556 4.68705C4.34395 4.74312 4.44904 4.77676 4.53079 4.77676C5.17304 4.78797 5.81529 4.78797 6.44586 4.77676C6.53928 4.77676 6.66773 4.72069 6.72611 4.65342C7.9172 3.45362 9.08493 2.25382 10.276 1.06524C10.4512 0.897044 10.5096 0.728848 10.4395 0.5158C7.13482 0.5158 3.8535 0.5158 0.490446 0.5158ZM6.45754 10.316C6.45754 8.61162 6.45754 6.95209 6.45754 5.30377C5.80361 5.30377 5.17304 5.30377 4.53079 5.30377C4.53079 6.57085 4.53079 7.82671 4.53079 9.07136C4.53079 9.13864 4.5775 9.22834 4.63588 9.25077C5.23142 9.60958 5.82696 9.94597 6.45754 10.316Z",
                                        fill: "white"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "front.provider.filter.button.provider"
                                      )
                                    ) +
                                    "\n                                    "
                                ),
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "10",
                                      height: "4",
                                      viewBox: "0 0 10 4",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M5 4L0 0L10 -1.74846e-06L5 4Z",
                                        fill: "#926D20"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  },
                  [
                    _c(
                      "v-list",
                      _vm._l(_vm.platforms, function(item, index) {
                        return _c("v-list-item", { key: item.id }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.checkedPlatformsIds,
                                expression: "checkedPlatformsIds"
                              }
                            ],
                            staticClass: "checkbox",
                            attrs: {
                              type: "checkbox",
                              id: "platform-select-check-" + index
                            },
                            domProps: {
                              value: item.id,
                              checked: Array.isArray(_vm.checkedPlatformsIds)
                                ? _vm._i(_vm.checkedPlatformsIds, item.id) > -1
                                : _vm.checkedPlatformsIds
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.checkedPlatformsIds,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = item.id,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.checkedPlatformsIds = $$a.concat([
                                          $$v
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.checkedPlatformsIds = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.checkedPlatformsIds = $$c
                                  }
                                },
                                _vm.platformFilterChanged
                              ]
                            }
                          }),
                          _c("label", {
                            attrs: { for: "platform-select-check-" + index },
                            domProps: { textContent: _vm._s(item.title) }
                          })
                        ])
                      }),
                      1
                    ),
                    _c("v-btn", { on: { click: _vm.selectAllPlatforms } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("front.provider.filter.button.select_all")
                        )
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "right" }, [
            _c("div", { staticClass: "sort" }, [
              _c("div", { staticClass: "sort__label" }, [
                _vm._v(_vm._s(_vm.$t("front.game.sort.titles.sort_by")))
              ]),
              _c(
                "ul",
                _vm._l(_vm.sortOptions, function(option) {
                  return _c(
                    "li",
                    {
                      key: option.value,
                      class: _vm.getSortOptionClass(option),
                      on: {
                        click: function($event) {
                          return _vm.sortOptionChanged(option)
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(option.name) + "\n                            "
                      )
                    ]
                  )
                }),
                0
              )
            ]),
            _c(
              "div",
              { staticClass: "sort-games-menu" },
              [
                _c(
                  "v-menu",
                  {
                    attrs: {
                      "offset-y": "",
                      right: "",
                      "max-width": "100px",
                      attach: ".sort-games-menu",
                      "content-class": "v-menu-sort"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  { staticClass: "btn-select sort-menu" },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.$t("front.game.sort.button.sort_by")
                                    ) +
                                    "\n                                    "
                                ),
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "10",
                                      height: "4",
                                      viewBox: "0 0 10 4",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M6 -0.000279474L12 5.14258L0 5.14258L6 -0.000279474Z",
                                        fill: "#926D20"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  },
                  [
                    _c(
                      "v-list",
                      _vm._l(_vm.sortOptions, function(option) {
                        return _c(
                          "v-list-item",
                          {
                            key: option.value,
                            class: _vm.getSortOptionClass(option),
                            on: {
                              click: function($event) {
                                return _vm.sortOptionChanged(option)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(option.name) +
                                "\n                                "
                            )
                          ]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }